const UserScreenId = {
    payment: {
        id: "payment",
        pathname: "/payment"
    },
    cargoInsurance: {
        id: "cargo-insurance",
        pathname: "/vas/cargo-insurance"
    },
    lcvBooking: {
        id: "lcv-booking",
        pathname: "/lcv-booking"
    },
    listing: {
        id: "listing",
        pathname: "/ac/my-loads/listing"
    }
};

export { UserScreenId };
//# sourceMappingURL=userScreenId.js.map
